import React ,{useState,useEffect,useRef} from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Box,
  TextField,
  Autocomplete,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Divider,Radio, IconButton
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AddOutlined ,RemoveCircleOutline} from "@mui/icons-material";
import { api } from "../../services/api";


const SYSTEM_PARENTS = new Set([
  "subscriptionKey",
  "accountId",
  "ActiveAccountID",
  "userId",
]);

const resolveParentValue = (rawValue) => {
  if (Array.isArray(rawValue)) {
    const v = rawValue[0];
    return v?.value ?? v?.label ?? v?.text ?? v ?? null;
  }

  if (typeof rawValue === "object" && rawValue !== null) {
    return rawValue.value ?? rawValue.label ?? rawValue.text ?? null;
  }

  return rawValue ?? null;
};

const applySystemReplacements = (url, {
  activeAccountId,
  subscriptionKey,
  userId,
}) => {
  if (activeAccountId) {
    url = url
      .replace("{ActiveAccountID}", activeAccountId)
      .replace("{ActiveAccountId}", activeAccountId)
      .replace("{accountId}", activeAccountId)
       .replace("{activeAccountId}", activeAccountId);
  }

  if (subscriptionKey) {
    url = url.replace("{subscriptionKey}", subscriptionKey);
  }

  if (userId) {
    url = url.replace("{userId}", userId);
  }

  return url;
};

const buildDropdownUrl = ({
  field,
  formData,
  activeAccountId,
  subscriptionKey,
  userId,
  extraValues = {}
    
}) => {
  let url = applySystemReplacements(field.dropdownSource, {
    activeAccountId,
    subscriptionKey,
    userId,
  });

  const placeholders = [...url.matchAll(/\{(.*?)\}/g)].map((m) => m[1]);

  for (const parent of placeholders) {
    if (SYSTEM_PARENTS.has(parent)) continue;


    // const rawParentValue = formData[parent]?.value;
    const rawParentValue = extraValues[parent] ?? formData[parent]?.value;
    const parentValue = resolveParentValue(rawParentValue);

    if (!parentValue) return null;

    url = url.replace(`{${parent}}`, encodeURIComponent(parentValue));
  }

  return url;
};

const getOptionLabelGeneric = (option) => {
  if (option == null) return "";
  if (typeof option === "string") return option;
  return option.text ?? option.label ?? option.value ?? "";
};

const normalizeOptions = (apiData, field) => {
  const map = new Map();

  apiData.forEach((item) => {
    const value = item[field.valueField] ?? item.value;
    const label = item[field.labelField] ?? item.label ?? item.text ?? item.value;

    if (!map.has(String(value))) {
      map.set(String(value), {
        value: String(value),
        label,
        text: label,
      });
    }
  });

  return Array.from(map.values());
};

const ListenersNLBAccordion = ({
  field,
  formConfig,
  formData,
  setFormData,
  activeAccountId,
  selectedProvider,
  userId,
  formSubmitted,
  resourceId,
}) => {
  const subscriptionKey =
    selectedProvider?.toUpperCase() === "AWS"
      ? localStorage.getItem("selectedAccountId")
      : localStorage.getItem("selectedSubscription");

  const items = Array.isArray(formData[field.fieldName]?.value)
    ? formData[field.fieldName].value
    : [];

    const maxListeners = field?.maxCount || 50;
const [listenerLimitError, setListenerLimitError] = React.useState("");
  const [expandedIndex, setExpandedIndex] = React.useState(0);
  const [dropdownOptions, setDropdownOptions] = React.useState({});
  const [dropdownLoading, setDropdownLoading] = React.useState({});

  const collectionFields = field.collectionFields || [];

  const getFieldByName = (name) =>
    collectionFields.find((child) => child.fieldName === name);

  const protocolField = getFieldByName("Protocol");
  const portField = getFieldByName("Port");
  const targetGroupCollectionField = getFieldByName("TargetGroupCollection");

  const nestedFields = targetGroupCollectionField?.collectionFields || [];
  const targetGroupField = nestedFields.find((f) => f.fieldName === "TargetGroup");
  const weightField = nestedFields.find((f) => f.fieldName === "Weight");
//   const stickinessField = nestedFields.find(
//   (f) => f.fieldName === "TargetGroupStickiness"
// );

const stickinessField = getFieldByName("TargetGroupStickiness");




const checkIsTls = (item) => {
  const p = item?.Protocol?.value || "";
  return p.toUpperCase() === "TLS";
};

const hasTlsListener = (items || []).some(checkIsTls);
useEffect(() => {
  if (!hasTlsListener) return;

  extraRootFields.forEach(f => {
    if (f.dropdownType === "api") {
      fetchGlobalDropdownOptions(f);
    }
  });
}, [hasTlsListener, formData.location?.value,activeAccountId]);








const extraRootFields = (formConfig || []).filter(
  (f) => f.tabName === field.tabName && f.fieldName !== field.fieldName
);

const globalSubTabs = [
  ...new Set(extraRootFields.map(f => f.subTab).filter(Boolean))
];


const [globalApiDropdownData, setGlobalApiDropdownData] = useState({});
const globalFetchCacheRef = useRef({});


const fetchGlobalDropdownOptions = async (f) => {
  if (f.dropdownType !== "api") return;

  let url = buildDropdownUrl({
    field: f,
    formData,
    activeAccountId,
    subscriptionKey,
    userId
  });

  const region = formData?.location?.value;
  const accountId =
    activeAccountId || formData?.ActiveAccountID?.value;

  //  critical fix
  if (!url || !region || !accountId) return;

  try {
    const response = await api.get(url, {
      params: {
        region,
        activeAccountId: accountId,
      },
    });

    const apiData = Array.isArray(response.data)
      ? response.data
      : response.data?.data || response.data?.result || [];

    const options = apiData.map(item => ({
      value: item[f.valueField] ?? item.value,
      label:
        item[f.labelField] ??
        item.label ??
        item.text ??
        item.value,
    }));

    setGlobalApiDropdownData(prev => ({
      ...prev,
      [f.fieldName]: options,
    }));
  } catch (err) {
    console.error("Global dropdown error:", err);
    setGlobalApiDropdownData(prev => ({
      ...prev,
      [f.fieldName]: [],
    }));
  }
};



const isDuplicateListener = (currentIndex, protocol, port) => {
  return items.some((item, idx) => {
    if (idx === currentIndex) return false;

    return (
      String(item?.Protocol?.value).toUpperCase() === String(protocol).toUpperCase() &&
      String(item?.Port?.value) === String(port)
    );
  });
};





  const getStaticOptions = (childField) => {
  if (!childField?.dropdownValues) return [];
  try {
    const parsed = JSON.parse(childField.dropdownValues);
    return parsed.map((o) => ({
      value: String(o.value),
      label: o.label ?? o.text ?? o.value,
      text: o.label ?? o.text ?? o.value,
    }));
  } catch {
    return [];
  }
};



const getDefaultChildValue = (childField) => {
  if (childField.fieldType === "multiSelectDropdown") {
    return { value: [], label: "" };
  }

  if (childField.fieldType === "checkbox") {
    return { value: false, label: "false" };
  }

  if (childField.defaultValue != null && childField.defaultValue !== "") {
    return {
      value: String(childField.defaultValue),
      label: String(childField.defaultValue),
    };
  }

  if (childField.fieldType === "collection") {
    return { value: [] };
  }

  return { value: "", label: "" };
};


const getDefaultTargetGroupRow = () => {
  const row = {};

  nestedFields.forEach((nestedField) => {
    row[nestedField.fieldName] = getDefaultChildValue(nestedField);
  });

  return row;
};

const getDefaultListener = () => {
  const row = {};

  collectionFields.forEach((childField) => {
    if (childField.fieldType === "collection") {
      row[childField.fieldName] = {
        value: [getDefaultTargetGroupRow()],
      };
    } else {
      row[childField.fieldName] = getDefaultChildValue(childField);
    }
  });

  return row;
};

const updateListenersState = (next) => {
  setFormData((prev) => ({
    ...prev,
    [field.fieldName]: {
      value: next,
      label: `${next.length} listeners`,
    },
  }));
};




const addListener = () => {
  if (items.length >= maxListeners) {
    setListenerLimitError(`Maximum ${maxListeners} listeners allowed`);
    return;
  }

  setListenerLimitError("");
  const next = [...items, getDefaultListener()];
  updateListenersState(next);
  setExpandedIndex(next.length - 1);
};




const removeListener = (listenerIdx) => {
  const next = items.filter((_, i) => i !== listenerIdx);
  updateListenersState(next);
  setExpandedIndex(Math.max(0, listenerIdx - 1));

  if (next.length < maxListeners) {
    setListenerLimitError("");
  }
};


const updateListenerChild = (listenerIdx, childName, value, label = "") => {
  const next = items.map((item, i) =>
    i !== listenerIdx
      ? item
      : {
          ...item,
          [childName]: {
            value,
            label: label || String(value),
          },
        }
  );

  updateListenersState(next);
};

const addNestedRow = (listenerIdx, collectionName) => {
  const next = items.map((item, i) => {
    if (i !== listenerIdx) return item;

    const existingRows = Array.isArray(item[collectionName]?.value)
      ? item[collectionName].value
      : [];

    const maxCount = targetGroupCollectionField?.maxCount || 5;

    if (existingRows.length >= maxCount) return item;

    return {
      ...item,
      [collectionName]: {
        value: [...existingRows, getDefaultTargetGroupRow()],
      },
    };
  });

  updateListenersState(next);
};

const removeNestedRow = (listenerIdx, collectionName, nestedIdx) => {
  const next = items.map((item, i) => {
    if (i !== listenerIdx) return item;

    const existingRows = Array.isArray(item[collectionName]?.value)
      ? item[collectionName].value
      : [];

    return {
      ...item,
      [collectionName]: {
        value: existingRows.filter((_, idx) => idx !== nestedIdx),
      },
    };
  });

  updateListenersState(next);
};

const updateNestedChild = (
  listenerIdx,
  collectionName,
  nestedIdx,
  childName,
  value,
  label = ""
) => {
  const next = items.map((item, i) => {
    if (i !== listenerIdx) return item;

    const existingRows = Array.isArray(item[collectionName]?.value)
      ? item[collectionName].value
      : [];

    const updatedRows = existingRows.map((row, idx) =>
      idx !== nestedIdx
        ? row
        : {
            ...row,
            [childName]: {
              value,
              label: label || String(value),
            },
          }
    );

    return {
      ...item,
      [collectionName]: {
        value: updatedRows,
      },
    };
  });

  updateListenersState(next);
};

const calculatePercent = (listenerIdx, nestedIdx) => {
  const groups =
    items[listenerIdx]?.[targetGroupCollectionField?.fieldName]?.value || [];

  const totalWeight = groups.reduce(
    (sum, tg) => sum + Number(tg?.Weight?.value || 0),
    0
  );

  if (!totalWeight) return "0%";

  const currentWeight = Number(groups[nestedIdx]?.Weight?.value || 0);
  return `${Math.round((currentWeight / totalWeight) * 100)}%`;
};

const fetchDropdownOptions = React.useCallback(
  async (childField) => {
    if (!childField?.dropdownSource) return;

    if (childField.dropdownType !== "api") return;

    setDropdownLoading((prev) => ({
      ...prev,
      [childField.fieldName]: true,
    }));

    try {

      const url = buildDropdownUrl({
        field: childField,
        formData,
        activeAccountId,
        subscriptionKey,
        userId,
         extraValues: {
    Protocol: items[expandedIndex]?.Protocol?.value,
    protocol: items[expandedIndex]?.Protocol?.value,
    resourceTypeId: resourceId,
  },
      });

      if (!url) {
        setDropdownOptions((prev) => ({
          ...prev,
          [childField.fieldName]: [],
        }));
        return;
      }

      // const response = await api.get(url);
      const response = await api.get(url);

      const apiData = Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.data?.data)
        ? response.data.data
        : Array.isArray(response.data?.result)
        ? response.data.result
        : [];

      const normalized = normalizeOptions(apiData, childField);

      setDropdownOptions((prev) => ({
        ...prev,
        [childField.fieldName]: normalized,
      }));
    } catch (error) {
      console.error(`Error fetching dropdown for ${childField.fieldName}`, error);
      setDropdownOptions((prev) => ({
        ...prev,
        [childField.fieldName]: [],
      }));
    } finally {
      setDropdownLoading((prev) => ({
        ...prev,
        [childField.fieldName]: false,
      }));
    }
  },
  [formData, activeAccountId, subscriptionKey, userId,items, expandedIndex, field.fieldId]
);

React.useEffect(() => {
  if (!items.length) {
    addListener();
    return;
  }

  const allFields = [
    ...collectionFields,
    ...nestedFields,
  ];

  allFields.forEach((childField) => {
    if (childField.fieldType === "dropdown" && childField.dropdownType === "api") {
      fetchDropdownOptions(childField);
    }
  });

  }, [formData.location?.value, formData.vpcId?.value, JSON.stringify(items.map(i => i?.Protocol?.value))]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [formData.location?.value, formData.vpcId?.value]);

const getOptionsForField = (childField) => {
  if (childField.dropdownType === "api") {
    return dropdownOptions[childField.fieldName] || [];
  }

  return getStaticOptions(childField);
};

const getListenerTitle = (item, idx) => {
  const protocol = item?.Protocol?.value || "Listener";
  const port = item?.Port?.value || "";
  return port ? `${protocol} : ${port}` : `${protocol} ${idx + 1}`;
};

const isEmptyValue = (value) => {
  if (Array.isArray(value)) return value.length === 0;
  return value === undefined || value === null || String(value).trim() === "";
};

const hasFieldError = (fieldConfig, value) => {
  if (!formSubmitted) return false;
  if (!fieldConfig?.isRequired) return false;
  return isEmptyValue(value);
};


const hasVisibleGlobalTabs = globalSubTabs.some(subTabName => {
  const isSecurityTab = subTabName.toLowerCase().includes("secure");

  if (isSecurityTab && !hasTlsListener) return false;

  const fields = extraRootFields.filter(f => f.subTab === subTabName);
  return fields.length > 0;
});


const hasNestedCollectionError = (collectionField, rows) => {
  if (!formSubmitted) return false;
  if (!collectionField?.isRequired) return false;
  return !Array.isArray(rows) || rows.length === 0;
};

const listenerCollectionError =
  formSubmitted &&
  field?.isRequired &&
  (!Array.isArray(items) || items.length === 0);

return (
  <Box sx={{ mt: 1.5, width: "100%" }}>

    {listenerCollectionError && (
    <Typography color="error" sx={{ mb: 1, fontSize: "0.75rem" }}>
      At least one listener is required
    </Typography>
  )}

    {items.map((item, idx) => {
      const expanded = expandedIndex === idx;
      const nestedRows = Array.isArray(item?.[targetGroupCollectionField?.fieldName]?.value)
        ? item[targetGroupCollectionField.fieldName].value
        : [];
const listenerProtocol =
  item?.Protocol?.value?.toUpperCase?.() || "";

const supportsStickiness =
  ["TCP", "UDP", "TCP_UDP"].includes(listenerProtocol);

      return (
        <Accordion
          key={idx}
          expanded={expanded}
          onChange={() => setExpandedIndex(expanded ? -1 : idx)}
          disableGutters
          square
          sx={{ mb: 2, borderRadius: "8px", border: "1px solid", borderColor: "divider", "&::before": { display: "none" } }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ display: "flex", alignItems: "center", pl: 1 }}>
              {getListenerTitle(item, idx)}
            </Typography>

            {items.length > 1 && (
              <Button
                size="small"
                color="error"
                onClick={(e) => {
                  e.stopPropagation();
                  removeListener(idx);
                }}
                sx={{ ml: "auto", textTransform: "none" }}
              >
                Remove
              </Button>
            )}
          </AccordionSummary>

           <AccordionDetails sx={{ pt: 1, pb: 3, px: 3 }}>
            {/* Top level listener fields */}
            <Box
              sx={{
                // display: "flex",
                // flexWrap: "wrap",
                // gap: 3,
                
                
 display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      md: "1fr 1fr"
    },
    rowGap: 1.5,
    columnGap: 3,
    alignItems: "start"



              }}
            >
              {collectionFields
                .filter((childField) => childField.fieldType !== "collection" 
                && childField.isDisplay !== false
              )
                .map((childField) => {
                  const currentValue = item?.[childField.fieldName]?.value ?? "";
                  const options = getOptionsForField(childField);
                  const loading = dropdownLoading[childField.fieldName];
const isDuplicate =
  childField.fieldName === "Port" &&
  isDuplicateListener(idx, item?.Protocol?.value, currentValue);
                  return (
                    <Box
                      key={childField.fieldId || childField.fieldName}
                      sx={{ width: "100%"
                        // flex: "1 1 300px",alignItems: "center",  minWidth: "260px" 
                      }}
                    >
                      {childField.fieldType === "text" && (
  
   <TextField
    fullWidth
    size="medium"
    label={childField.fieldLabel}
    required={childField.isRequired}
    type={childField.fieldName === "Port"}
    value={currentValue}
    error={
      hasFieldError(childField, currentValue) || isDuplicate ||
      (childField.fieldName === "Port" &&
        currentValue !== "" &&
        (Number(currentValue) < 1 || Number(currentValue) > 65535))
    }
    helperText={isDuplicate? "Listener with same protocol and port already exists"
      :hasFieldError(childField, currentValue)
        ? "This field is required"
        : childField.fieldName === "Port" &&
          currentValue !== "" &&
          (Number(currentValue) < 1 || Number(currentValue) > 65535)
        ? "Port must be between 1 and 65535"
        : childField.fieldName === "Port"
        ? "1-65535"
        : ""
    }
    onChange={(e) => {
      let value = e.target.value;

      if (childField.fieldName === "Port") {
        // allow only digits
        value = value.replace(/\D/g, "");



if (value.length > 1 && value.startsWith("00")) {
    return;
  }

  // Convert 01 -> 1, 05 -> 5, 080 -> 80
  if (value.length > 1 && value.startsWith("0")) {
    value = String(Number(value));
  }


        // optional: prevent entering more than 65535
        if (value !== "" && Number(value) > 65535) {
          value = "65535";
        }
      }

      updateListenerChild(
        idx,
        childField.fieldName,
        value,
        value
      );
    }}
    inputProps={
      childField.fieldName === "Port"
         ? {
          inputMode: "numeric",
          pattern: "[0-9]*",
          maxLength: 5,
        }
      : {}
    }
  />



                      )}

                      {childField.fieldType === "dropdown" && (
                        
                        <Autocomplete
    options={options}
    loading={loading}
    value={
      options.find(
        (o) => String(o.value) === String(currentValue)
      ) || null
    }
    getOptionLabel={getOptionLabelGeneric}
    isOptionEqualToValue={(opt, val) =>
      String(opt.value) === String(val?.value)
    }
    onChange={(e, newValue) =>
      updateListenerChild(
        idx,
        childField.fieldName,
        newValue?.value || "",
        newValue?.label || newValue?.text || ""
      )
    }
    renderInput={(params) => (
      <TextField
        {...params}
        label={childField.fieldLabel}
        required={childField.isRequired}
        size="medium"
        error={hasFieldError(childField, currentValue)}
        helperText={
          hasFieldError(childField, currentValue)
            ? "This field is required"
            : ""
        }
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {loading ? (
                <CircularProgress color="inherit" size={18} />
              ) : null}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    )}
  />
                      )}
                    </Box>
                  );
                })}
            </Box>

            {/* Nested collection section */}
            {targetGroupCollectionField && (
              <Box sx={{ width: "100%", pt: 2}}>
                

<Typography sx={{ fontSize: "16px", fontWeight: 600, mb: 3 }}>
      Forward to target group 
      <Typography sx={{display:'block',color:'grey',fontWeight:400,fontSize:"12px"}} component="span">Choose a target group and specify routing weight </Typography>
    </Typography>

{hasNestedCollectionError(targetGroupCollectionField, nestedRows) && (
  <Typography color="error" sx={{ mb: 1, fontSize: "0.75rem" }}>
    At least one {targetGroupCollectionField.fieldLabel} is required
  </Typography>
)}
                {nestedRows.map((nestedRow, nestedIdx) => (
                  <Box
                    key={nestedIdx}
                    sx={{
                      display: "grid",
                      // gridTemplateColumns: "1fr 160px 100px 120px",
                      
gridTemplateColumns: {
  xs: "1fr",
  md: "4fr 1.5fr 80px 40px"
},

                      gap: 2,
                      mb: 2,
                      alignItems: "start",
                    }}
                  >
                    {/* TargetGroup */}
                    {targetGroupField && (
                      
                      <Autocomplete
    options={getOptionsForField(targetGroupField)}
    loading={dropdownLoading[targetGroupField.fieldName]}
    value={
      (getOptionsForField(targetGroupField) || []).find(
        (o) =>
          String(o.value) ===
          String(nestedRow?.[targetGroupField.fieldName]?.value)
      ) || null
    }
    getOptionLabel={getOptionLabelGeneric}
    isOptionEqualToValue={(opt, val) =>
      String(opt.value) === String(val?.value)
    }
    getOptionDisabled={(option) =>
    nestedRows.some(
      (r, rIdx) =>
        rIdx !== nestedIdx &&
        Boolean(r?.[targetGroupField.fieldName]?.value) &&
        String(r?.[targetGroupField.fieldName]?.value) === String(option.value)
    )
  }
    onChange={(e, newValue) =>
      updateNestedChild(
        idx,
        targetGroupCollectionField.fieldName,
        nestedIdx,
        targetGroupField.fieldName,
        newValue?.value || "",
        newValue?.label || newValue?.text || ""
      )
    }
    renderInput={(params) => (
      <TextField
        {...params}
        label={targetGroupField.fieldLabel}
        required={targetGroupField.isRequired}
        size="medium"
        error={hasFieldError(
          targetGroupField,
          nestedRow?.[targetGroupField.fieldName]?.value
        )}
        helperText={
          hasFieldError(
            targetGroupField,
            nestedRow?.[targetGroupField.fieldName]?.value
          )
            ? "This field is required"
            : ""
        }
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {dropdownLoading[targetGroupField.fieldName] ? (
                <CircularProgress color="inherit" size={18} />
              ) : null}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    )}
  />
                    )}

                    {/* Weight */}
                    {weightField && (
 <TextField
  size="medium"
  type="text"
  label={weightField.fieldLabel}
  required={weightField.isRequired}
  value={nestedRow?.[weightField.fieldName]?.value ?? ""}
  // disabled={nestedRows.length === 1}
   disabled={!nestedRow?.[targetGroupField?.fieldName]?.value}
  error={
    nestedRows.length !== 1 &&
    (
      hasFieldError(weightField, nestedRow?.[weightField.fieldName]?.value) ||
      (
        nestedRow?.[weightField.fieldName]?.value !== "" &&
        (
          Number(nestedRow?.[weightField.fieldName]?.value) < 0 ||
          Number(nestedRow?.[weightField.fieldName]?.value) > 999
        )
      )
    )
  }
  helperText={
    nestedRows.length !== 1 &&
    hasFieldError(weightField, nestedRow?.[weightField.fieldName]?.value)
      ? "This field is required"
      : nestedRows.length !== 1 &&
        nestedRow?.[weightField.fieldName]?.value !== "" &&
        (
          Number(nestedRow?.[weightField.fieldName]?.value) < 0 ||
          Number(nestedRow?.[weightField.fieldName]?.value) > 999
        )
      ? "Weight must be between 0 and 999"
      : "0-999"
  }
  onChange={(e) => {
    let value = e.target.value.replace(/\D/g, "");

    if (value !== "" && Number(value) > 999) {
      value = "999";
    }
    if (value === "0") {

value = "1";

}

    // Prevent 00, 000, etc.

if (value.length > 1 && value.startsWith("00")) {

return;

}
// Convert 01 -> 1, 05 -> 5

if (value.length > 1 && value.startsWith("0")) {

value = String(Number(value));

}


    updateNestedChild(
      idx,
      targetGroupCollectionField.fieldName,
      nestedIdx,
      weightField.fieldName,
      value,
      value
    );
  }}
   inputProps={{
    inputMode: "numeric",
    pattern: "[0-9]*",
    maxLength: 3,
  }}
/>


                    )}

                    {/* Percent */}

                    <Box sx={{ 
                      // display: "block", alignItems: "center", height: "40px"
                      
display: "flex",  
    flexDirection: "column",
    justifyContent: "flex-start",
    mt: 0.5


                     }}>
                     <Typography  variant="title"  sx={{ fontSize: "14px" }}>
                        Percent
                      </Typography>
                      <Typography sx={{ fontSize: "14px" }}>
                        {calculatePercent(idx, nestedIdx)}
                      </Typography>
                    </Box>

                    {/* Remove nested row */}
                    <Box sx={{ display: "flex", alignItems: "center", height: "40px" }}>
                     


<Box sx={{ display: "flex", alignItems: "center", height: "40px" }}>
  {nestedRows.length > 1 && (
   

<IconButton
  color="error"
  sx={{ mt: 0.5 }}
  onClick={() =>
    removeNestedRow(
      idx,
      targetGroupCollectionField.fieldName,
      nestedIdx
    )
  }
>
  <RemoveCircleOutline />
</IconButton>

  )}
</Box>


                    </Box>
                  </Box>
                ))}

                {(nestedRows.length < (targetGroupCollectionField.maxCount || 5)) && (
                  <Button
                    startIcon={<AddOutlined />}
                    onClick={() =>
                      addNestedRow(idx, targetGroupCollectionField.fieldName)
                    }
                    sx={{
                      mt: 1,
                      textTransform: "none",
                      fontWeight: 600,
                      p: 0,
                    }}
                  >
                    Add Target Group
                  </Button>
                )}


                {stickinessField  && supportsStickiness &&(

  <Box sx={{ mt: 3 }}>
    <Typography sx={{ fontSize: "16px", fontWeight: 600,  }}>
      {stickinessField.subTab || "Target group stickiness"}
    </Typography>


    <Typography sx={{ fontSize: "13px", color:'grey',fontWeight:400,fontSize:"12px", mb: 1 }}>
      Enables the load balancer to bind a user's session to a specific target group.
    </Typography>

    <FormControlLabel
      control={
        <Checkbox
          checked={Boolean(
           item?.[stickinessField.fieldName]?.value
          )}
          onChange={(e) =>
           
updateListenerChild(
  idx,
  stickinessField.fieldName,
  e.target.checked,
  String(e.target.checked)
)

          }
        />
      }
      label={stickinessField.fieldLabel}
    />
  </Box>
)}

              </Box>
            )}
          </AccordionDetails>
        </Accordion>
      );
    })}
{listenerLimitError && (
  <Typography color="error" sx={{ mt: 1, fontSize: "0.75rem" }}>
    {listenerLimitError}
  </Typography>
)}


<Button
  startIcon={<AddOutlined />}
  onClick={addListener}
  disabled={items.length >= maxListeners}
  sx={{
    mt: 2,
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "20px",
    border: "1px solid",
    borderColor: "primary.main",
    px: 2,
  }}
  variant="outlined"
>
  Add Listener
</Button>







{hasVisibleGlobalTabs && (
  <>
    <Divider sx={{ mt: 3, mb: 2 }} />
 {globalSubTabs.map((subTabName) => {
  const isSecurityTab = subTabName.toLowerCase().includes("secure");

  //  show only when TLS selected
  if (isSecurityTab && !hasTlsListener) return null;

  const subTabFields = extraRootFields.filter(
    f => f.subTab === subTabName
  );

  return (
    <Box key={subTabName} sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        {subTabName}
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: 2,
        }}
      >
        {subTabFields.map((f) => {
          const value = formData?.[f.fieldName]?.value || "";

          //  STEP 1: handle dependency (Protocol / CertificateSource)
if (f.dependentOn && f.dependentValue) {
  const depVal = formData?.[f.dependentOn]?.value;

  // Special case: Protocol comes from listener (not root)
  if (f.dependentOn === "Protocol") {
    if (!hasTlsListener) return null;
  } else {
    if (!depVal || depVal !== f.dependentValue) {
      return null;
    }
  }
}


         if (f.fieldType === "dropdown") {
            const options =
              globalApiDropdownData[f.fieldName] || [];
              
            const isFullWidth = f.fieldName.toLowerCase().includes("acm") || f.fieldName.toLowerCase().includes("certificate");

            return (
              <Autocomplete
                key={f.fieldName}
                options={options}
                sx={{ gridColumn: isFullWidth ? "1 / -1" : "auto" }}
                value={
                  options.find(o => o.value === value) || null
                }
                getOptionLabel={(o) => o.label}
                onChange={(e, val) => {
                  setFormData(prev => ({
                    ...prev,
                    [f.fieldName]: {
                      value: val?.value || "",
                      label: val?.label || "",
                    },
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={f.fieldLabel}
                    required={f.isRequired}
                    
                    error={hasFieldError(f, value)}
                    helperText={
                      hasFieldError(f, value)
                        ? `${f.fieldLabel} is required`
                        : ""
                    }

                  />
                )}
              />
            );
          }

        

if (f.fieldType?.toLowerCase() === "radio button") {
            let rawOptions = [];

            if (f.dropdownValues) {
              try {
                rawOptions = JSON.parse(f.dropdownValues);
              } catch {}
            }

            const options = rawOptions.map(o => ({
              value: o.value,
              label: o.label,
            }));

            const valueStr = String(value || "");
            const isError = hasFieldError(f, valueStr); 
            return (
    <Box key={f.fieldName} 
    // sx={{ gridColumn: "1 / -1" }}
              >
      {/* <Typography sx={{ mb: 1 }}>
        {f.fieldLabel}
      </Typography> */}

                  {options.map((opt) => {
                    const isSelected = valueStr === String(opt.value);

                    return (
                      <Box
                        key={opt.value}
                        onClick={() =>
                          setFormData(prev => ({
                            ...prev,
                            [f.fieldName]: {
                              value: opt.value,
                              label: opt.label,
                            },
                          }))
                        }
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          px: 2,
                          py: 1,
                          minHeight: "56px",
                          width: "100%",
                          borderRadius: "6px",
                          border: "1px solid",
                          borderColor: isError && !isSelected ? "error.main" : (isSelected ? "primary.main" : "grey.300"),
                          backgroundColor: isSelected
                            ? "rgba(25,118,210,0.08)"
                            : "#fff",
                          cursor: "pointer",
                          transition: "0.2s",

                          "&:hover": {
                            borderColor: isError && !isSelected ? "error.main" : "primary.main",
                          },
                        }}
                      >
                        <Radio
                          size="small"
                          checked={isSelected}
                          sx={{ 
                            p: 0, 
                            color: isError && !isSelected ? "error.main" : undefined 
                          }}
                        />

                        <Typography sx={{ 
                          fontSize: "14px", 
                          color: isError && !isSelected ? "error.main" : "text.primary" 
                        }}>
                          {opt.label}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
            );
          }



          return null;
        })}
      </Box>
    </Box>
  );
})}
</>)}
    
  </Box>
);
};

export default ListenersNLBAccordion;